import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUser } from '@app/store/slices/userSlice';
import { getAccessToken } from '@app/api/tokenService';
import { useNotificationsPolling } from '@app/api/auth/useNotificationsPolling';

export default function UserInitializer({ children }) {
  const dispatch = useDispatch();
  const isInitialized = useSelector((state) => state.user.isInitialized);

  useEffect(() => {
    if (!isInitialized && getAccessToken()) {
      dispatch(fetchUser());
    }
  }, [dispatch, isInitialized]);

  useNotificationsPolling();

  return children;
}
